import BlogPostCard from './BlogPostCard'
import type { ResourceCenterBlog } from '../../app/(site)/(opentelemetry-hub-routes)/content'

interface FeaturedBlogsProps {
  isDarkMode: boolean
  posts: ResourceCenterBlog[]
}

function FeaturedBlogs({ isDarkMode, posts }: FeaturedBlogsProps) {
  const primaryFeaturedBlogs = posts.slice(0, 2)
  const secondaryFeaturedBlogs = posts.slice(2, 5)

  return (
    <div className="my-8 flex flex-col">
      <div
        className={`w-full text-sm font-semibold uppercase leading-5 tracking-wide max-md:max-w-full ${'text-[var(--l2-foreground)]'}`}
      >
        featured blog posts
      </div>
      <div className="mt-5 w-full max-md:max-w-full">
        <div className="mt-4 grid gap-4 sm:grid-cols-1 md:grid-cols-2">
          {primaryFeaturedBlogs.map((featuredBlog) => {
            return <BlogPostCard blog={featuredBlog} key={featuredBlog.slug} />
          })}
        </div>
      </div>

      <div className="mt-4 grid gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {secondaryFeaturedBlogs.map((post) => {
          return <BlogPostCard blog={post} key={post.slug} />
        })}
      </div>
    </div>
  )
}

export default FeaturedBlogs
